import React from 'react';
import { Box } from '@mui/material';
import NavBar from '../components/navbar';
import Footer from '../components/footer';
import PageHero from '../components/PageHero';
import SectionHeader from '../components/SectionHeader';
import CtaSection from '../components/CtaSection';
import ScrollReveal from '../components/animated/ScrollReveal';
import Text from '../components/Text';
import { colors } from '../theme/designTokens';
import { insights } from '../data/insights';

const Insights = () => (
  <Box sx={{ bgcolor: colors.white, overflow: 'hidden' }}>
    <NavBar />
    <PageHero
      variant="dark"
      eyebrow="Insights"
      title="Thought Leadership."
      titleHighlight="That wins trust."
      subtitle="Articles, research, whitepapers, risk reports, and CEO perspectives—because every consultancy wins trust through ideas."
      badges={['Research', 'Frameworks', 'Briefings']}
    />

    <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 8, md: 12 } }}>
      <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <ScrollReveal>
          <SectionHeader
            eyebrow="Knowledge Centre"
            title="Ideas for adaptive organizations."
            highlightWords={['adaptive']}
          />
        </ScrollReveal>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {insights.map((item) => (
            <Box
              key={item.slug}
              sx={{
                p: { xs: 3, md: 4 },
                borderBottom: `1px solid ${colors.borderLight}`,
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '140px 1fr' },
                gap: 2,
              }}
            >
              <Box>
                <Text variant="eyebrow" sx={{ color: colors.slate, display: 'block', mb: 0.5 }}>
                  {item.type}
                </Text>
                <Text variant="caption" color="secondary">
                  {item.date}
                </Text>
              </Box>
              <Box>
                <Text variant="h3" color="primary" sx={{ mb: 1 }}>
                  {item.title}
                </Text>
                <Text variant="body" color="secondary">
                  {item.excerpt}
                </Text>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
    <CtaSection />
    <Footer />
  </Box>
);

export default Insights;
